module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM7.74945 6.75002C7.47338 6.47395 7.02579 6.47395 6.74972 6.75002C6.47365 7.02609 6.47365 7.47369 6.74972 7.74976L9.08249 10.0825L6.74982 12.4152C6.47375 12.6913 6.47375 13.1389 6.74982 13.4149C7.02589 13.691 7.47348 13.691 7.74955 13.4149L10.0822 11.0823L12.4149 13.4149C12.691 13.691 13.1386 13.691 13.4146 13.4149C13.6907 13.1389 13.6907 12.6913 13.4146 12.4152L11.082 10.0825L13.4147 7.74976C13.6908 7.47369 13.6908 7.02609 13.4147 6.75002C13.1387 6.47395 12.6911 6.47395 12.415 6.75002L10.0822 9.08279L7.74945 6.75002Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
